import React from "react";
const ThinkingIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width="14"
      height="14"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFD60B" cx="7" cy="7" r="7" />
        <rect
          fill="#000"
          fillRule="nonzero"
          x="6"
          y="4"
          width="2"
          height="2"
          rx="1"
        />
        <rect
          fill="#000"
          fillRule="nonzero"
          x="10"
          y="5"
          width="2"
          height="2"
          rx="1"
        />
        <path
          d="M7 0A7 7 0 1 1 .008 6.653 6.323 6.323 0 1 0 6.653.008C6.768.003 6.883 0 7 0Z"
          fill="#FFB000"
        />
        <path
          d="M7 0a6.989 6.989 0 0 1 5.58 2.774 7 7 0 0 0-9.807 9.807A7 7 0 0 1 7 0Z"
          fill="#FFEB97"
        />
        <circle stroke="#975F00" strokeWidth=".677" cx="7" cy="7" r="6.661" />
        <path fill="#FFF" d="M2 14V7h2.968v2.258H10v2.484H7.687V14z" />
        <path fill="#CCC" d="M2 12h5.113v2H2z" />
        <path
          d="M4.593 7.375v2.258h5.032v1.734h-2.21v2.258h-5.04v-6.25h2.218Z"
          stroke="#5A3900"
          strokeWidth=".75"
        />
        <path d="M6.206 7.71s3.326-.847 4.657.847" stroke="#000" />
        <path fill="#000" fillRule="nonzero" d="M10 3h2v1h-2zM6 2h2v1H6z" />
      </g>
    </svg>
  )
);
ThinkingIcon.displayName = "ThinkingIcon";
export default ThinkingIcon;
